import { AnimationShell, Icons, Link, Typography } from '@/components';
import { Route } from '@/constants';
import { cn } from '@/utils/styles';

import { useOfferHeaderDetails } from '../../hooks';

export type OfferHeaderViewProps = {
  readonly id: string;
};

export function OfferHeaderView({ id }: OfferHeaderViewProps) {
  const offer = useOfferHeaderDetails(id);
  if (!offer) return null;

  const statusName = offer.opportunity?.status?.name;

  const canShowOpenButton = statusName === 'published' || statusName === 'closed';

  return (
    <AnimationShell type="opacity" className={cn('mb-0')}>
      <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        {/* MOBILE + TABLET: special layout */}
        <div className="flex flex-col gap-3 lg:hidden">
          <div className="flex items-center">
            <Icons size="md" icons={offer.opportunity.technologies.icons.states} className="shrink-0" />

            <AnimationShell type="slide-left">
              <Typography as="h1" size="heading-2" color="primary" weight="semibold" className="ml-2 text-[22px]">
                {offer.opportunity.name}
              </Typography>
            </AnimationShell>
          </div>
        </div>

        {/* DESKTOP: Layout horizontal */}
        <div className="hidden lg:flex lg:flex-wrap lg:items-center lg:gap-3">
          <Icons size="xl" icons={offer.opportunity.technologies.icons.states} />
          <AnimationShell type="slide-left">
            <Typography as="h1" size="heading-2" color="primary" weight="semibold">
              {offer.opportunity.name}
            </Typography>
          </AnimationShell>
        </div>
      </div>
    </AnimationShell>
  );
}
